import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useActiveContextReady } from './useActiveContextReady';
import { config } from '../config';

const backendApi = config.backendApi;

export interface Plan {
  id: number;
  name: string;
  slug: string;
  base_price_monthly: string;
  base_price_annual: string;
  devices_included: number;
  devices_limit: number;
  gateways_included: number;
  gateways_limit: number;
  users_included: number;
  users_limit: number;
  regions_included: number;
  regions_limit: number;
}

const fetchPlans = async (): Promise<Plan[]> => {
  const response = await axios.get<Plan[]>(`${backendApi}/api/plans`, { withCredentials: true });
  return response.data;
};

export function usePlans(enabled = true) {
  const contextReady = useActiveContextReady();

  return useQuery<Plan[]>({
    queryKey: ['plans'],
    queryFn: fetchPlans,
    enabled: enabled && contextReady,
    staleTime: 300000, // 5 minutes - plans don't change often
  });
}
